module.exports = __webpack_public_path__ + "static/media/checkup-diagnosis-healthcare-svgrepo-com.e8903749.svg";